import * as moment from 'moment';

import { getSession } from '../services/storage.service';

const getParsedToken = () => parseJwt(getSession().token);

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');

  return JSON.parse(window.atob(base64));
};

export const getFirstname = () => {
  const decoded = getParsedToken();

  return decoded.firstname;
};

export const getFullname = () => {
  const decoded = getParsedToken();

  return `${decoded.firstname} ${decoded.lastname}`;
};

export const hasPinAccess = () => {
  const decoded = getParsedToken();

  return (!!decoded && decoded.pin);
};

export const isLoggedIn = () => {
  const decoded = getParsedToken();
  const controlTime = (decoded) ? ((decoded.exp - 5) * 1000 - decoded.delta) : 0;

  return (moment().valueOf() < controlTime);
};

export const isAdmin = () => {
  const decoded = getParsedToken();

  return (!!decoded && decoded.admin);
};



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/utils/jwt.utils.ts